import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

interface NavigationProps {
  isScrolled?: boolean;
}

export default function Navigation({ isScrolled: propIsScrolled }: NavigationProps) {
  const [isScrolled, setIsScrolled] = useState(propIsScrolled || false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (propIsScrolled !== undefined) return;

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [propIsScrolled]);

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-black shadow-lg' : 'bg-black'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16 sm:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center cursor-pointer">
            <img 
              src="https://static.readdy.ai/image/a76fc84099da4ca5f9486c73960e2672/739fc27163675d853e3f90f8de30a422.png" 
              alt="LCA Group" 
              className="h-10 sm:h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-6 lg:space-x-8">
            <Link
              to="/"
              className={`font-medium text-sm lg:text-base transition-colors cursor-pointer ${
                isActive('/') ? 'text-[#f59e0b]' : 'text-white hover:text-[#f59e0b]'
              }`}
            >
              Home
            </Link>
            <Link
              to="/services"
              className={`font-medium text-sm lg:text-base transition-colors cursor-pointer ${
                isActive('/services') ? 'text-[#f59e0b]' : 'text-white hover:text-[#f59e0b]'
              }`}
            >
              Services
            </Link>
            <Link
              to="/about"
              className={`font-medium text-sm lg:text-base transition-colors cursor-pointer ${
                isActive('/about') ? 'text-[#f59e0b]' : 'text-white hover:text-[#f59e0b]'
              }`}
            >
              About
            </Link>
            <Link
              to="/resources"
              className={`font-medium text-sm lg:text-base transition-colors cursor-pointer ${
                isActive('/resources') ? 'text-[#f59e0b]' : 'text-white hover:text-[#f59e0b]'
              }`}
            >
              Resources
            </Link>
            <Link
              to="/nj-lead-inspections"
              className={`font-medium text-sm lg:text-base transition-colors cursor-pointer ${
                isActive('/nj-lead-inspections') ? 'text-[#f59e0b]' : 'text-white hover:text-[#f59e0b]'
              }`}
            >
              NJ Lead Law
            </Link>
            <Link
              to="/contact"
              className="bg-[#f59e0b] text-white px-4 lg:px-6 py-2 lg:py-2.5 rounded-lg text-sm lg:text-base font-semibold hover:bg-[#d97706] transition-colors whitespace-nowrap cursor-pointer"
            >
              Contact Us
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 rounded-lg text-white hover:bg-white/10 transition-colors cursor-pointer"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden py-4 bg-black border-t border-gray-800">
            <div className="flex flex-col space-y-4">
              <Link
                to="/"
                className={`font-medium transition-colors cursor-pointer text-base ${
                  isActive('/') ? 'text-[#f59e0b]' : 'text-white hover:text-[#f59e0b]'
                }`}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Home
              </Link>
              <Link
                to="/services"
                className={`font-medium transition-colors cursor-pointer text-base ${
                  isActive('/services') ? 'text-[#f59e0b]' : 'text-white hover:text-[#f59e0b]'
                }`}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Services
              </Link>
              <Link
                to="/about"
                className={`font-medium transition-colors cursor-pointer text-base ${
                  isActive('/about') ? 'text-[#f59e0b]' : 'text-white hover:text-[#f59e0b]'
                }`}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                About
              </Link>
              <Link
                to="/resources"
                className={`font-medium transition-colors cursor-pointer text-base ${
                  isActive('/resources') ? 'text-[#f59e0b]' : 'text-white hover:text-[#f59e0b]'
                }`}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Resources
              </Link>
              <Link
                to="/nj-lead-inspections"
                className={`font-medium transition-colors cursor-pointer text-base ${
                  isActive('/nj-lead-inspections') ? 'text-[#f59e0b]' : 'text-white hover:text-[#f59e0b]'
                }`}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                NJ Lead Law
              </Link>
              <Link
                to="/contact"
                className="bg-[#f59e0b] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#d97706] transition-colors text-center whitespace-nowrap cursor-pointer text-base"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Contact Us
              </Link>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
